import useMutationApi from 'src/api/useMutationApi';
import { FamousShipmentDTO } from './useFamousShipments';

const useSyncFamousShipment = (
  shipmentId: string,
  onSuccess?: (data: FamousShipmentDTO) => void,
) => {
  return useMutationApi<Record<string, never>, FamousShipmentDTO>({
    endpoint: `famous/shipments/${shipmentId}/sync`,
    method: 'POST',
    options: {
      onSuccess: onSuccess ? (response) => onSuccess(response.data) : undefined,
    },
  });
};

export default useSyncFamousShipment;
